



















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Content, ContentTab, ContentItem, ScrollObject } from '@/models/HorizontalContentScroller';

@Component
export default class ProductListing extends Vue {
    protected content!: Content;
    protected title!: string;
    protected scrollStartPosition: number = 0;
    protected scrollEndPosition: number = 1000;
    protected scrollObject: ScrollObject = {
        ViewWidth: 1000,
        Gap: 10,
        Position: 0,
        Width: 500,
        Id: '',
        Target: 0,
        ScrollWidth: 0
    };
    protected eventListenersSet: Boolean = false;
    protected isTouchDevice: Boolean = false;
    protected compInstance: number = 0;

    constructor() {
        super();
        this.content = JSON.parse(this.$attrs['data-content']);
        this.title = this.$attrs['data-title'];

        this.$attrs['data-content'] = '';
    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    mounted() {
        if (this.$vnode.componentInstance) {
            this.compInstance = (this.$vnode.componentInstance as any)._uid;
        }
        setTimeout(this.setScrollObject, 1000);
        this.setScrollObject();
    }

    private isNextActive() {
        return Math.abs(this.scrollObject.Position - this.scrollObject.Width) > 2;
    }
    private isBackActive() {
        return this.scrollObject.Position !== 0;
    }

    private selectedTab() {
        return this.content.Tabs.filter(row => row.Selected);
    }

    private changeTab(tab: number) {
        this.content.Tabs.forEach(element => {
            element.Selected = false;
        });

        this.content.Tabs[tab].Selected = true;

        setTimeout(this.setScrollObject, 1000);
        // console.log('change tab', this.content.Tabs, tab);
    }

    private handleScroll(event: any) {
        this.setScrollObject();
    }

    private colsClass() {
        return 'cols-' + this.content.Cols;
    }

    private rowsClass() {
        return 'rows-' + this.content.Rows;
    }

    private noLazyLoad(image: string) {
        if (image != null) {
            return image.replace('lazyload', '');
        }

        return '';
    }

    private setScrollObject() {
        // @ts-ignore
        const scrollObject: ScrollObject = {};
        const tab = this.selectedTab();
        let ulId = '';

        if (tab != null && tab.length > 0) {
            ulId = '#scroll-list-' + this.compInstance + '-' + tab[0].Id;
            scrollObject.Id = ulId;
        }

        const ul = document.querySelector(ulId);

        if (ul != null) {
            const styles = window.getComputedStyle(ul);
            const columnGap = Number(styles.getPropertyValue('grid-column-gap').replace('px', ''));
            scrollObject.Gap = columnGap;
            // @ts-ignore
            scrollObject.Width = ul.scrollWidth - ul.offsetWidth;
            // @ts-ignore
            scrollObject.ViewWidth = ul.offsetWidth;
            scrollObject.Position = ul.scrollLeft;
            scrollObject.ScrollWidth = ul.scrollWidth;
            scrollObject.Target = this.scrollObject.Target;
        }

        this.scrollObject = scrollObject;

        // console.log(
        //     'scrollobject',
        //     this.scrollObject.Id,
        //     this.scrollObject.Width,
        //     this.scrollObject.ViewWidth,
        //     this.scrollObject.ScrollWidth,
        //     this.scrollObject.Gap,
        //     this.scrollObject.Position,
        //     this.scrollObject.Target
        // );
    }
    private doSomething() {
        // console.log('end');
    }

    private scroll(ev: PointerEvent, adjust: number) {
        this.setScrollObject();
        const el = ev.target as HTMLElement;
        const parent = el.closest('.product-listing');
        if (parent) {
            const ul = parent.querySelector('ul.tab-container');
            if (ul != null) {
                this.scrollObject.Target =
                    this.scrollObject.Position + (this.scrollObject.ViewWidth + this.scrollObject.Gap) * adjust;
                ul.scrollTo({
                    left: this.scrollObject.Target,
                    behavior: 'smooth'
                });

                // @ts-ignore
                ul.onscroll = e => {
                    if (
                        ul != null &&
                        (ul.scrollLeft === this.scrollObject.Target || ul.scrollLeft === this.scrollObject.Width)
                    ) {
                        this.setScrollObject();
                        // @ts-ignore
                        ul.onscroll = null;
                    }
                };
            }
        }
    }
}
